import React from 'react';
import { Box, TextField, Select, MenuItem, FormControlLabel, Checkbox, TextareaAutosize, Grid, Button, Tooltip } from "@mui/material";
import Paper from "@mui/material/Paper";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import useFetch from "../../../utils/useFetch";
import axios from "../../../utils/fvAxios";
import { useState, useRef, useEffect, useLayoutEffect } from "react";


import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css'; // Import Quill bubble theme styles
import 'react-quill/dist/quill.core.css'; // Import Quill core styles
import 'react-quill/dist/quill.bubble.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";


export default function EmployeeCerdentials({ handleClose1, emailData }) {
    const [Emailtemplate, setEmailtemplate] = useState([]);
    const [to, setTo] = useState("");
    const [ccAddress, setCcAddress] = useState("");

    const [subject, setSubject] = useState("");
    const [body, setBody] = useState("");
    const [emailComment, setEmailComment] = useState("");
    const [checked, setChecked] = useState();
    const [isFormValid, setIsFormValid] = useState(false);

    const [Dis, setDis] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { data: res } = useFetch(
        "Employee/GetEmployeeCredentials?userId=" + emailData
    );
    useEffect(() => {
        if (res?.data) {
            setEmailtemplate(res?.data);
            setTo(res?.data?.toAddress);
            setCcAddress(res?.data?.ccAddress);
            setSubject(res?.data?.subject);
            setBody(res?.data?.body);
        };
    }, [res]);

    const SendEmail = async () => {
        setDis(true);
        setIsLoading(true);
        const No = "3fa85f64-5717-4562-b3fc-2c963f66afa6"
        const formData = new FormData();
        formData.append("userId", No);
        formData.append("toAddress", to + "");
        formData.append("ccAddress", ccAddress + "");
        formData.append("subject", subject + "");
        formData.append("body", body + "");
        formData.append("employeeUserName", Emailtemplate?.employeeUserName + "");
        formData.append("employeePassword", Emailtemplate?.employeePassword + "");
        formData.append("languageCode", Emailtemplate?.languageCode + "");
        formData.append("attachments", null);

        const location = {
            "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "toAddress": to + "",
            "ccAddress": ccAddress + "",
            "subject": subject + "",
            "body": body + "",
            "employeeUserName": Emailtemplate?.employeeUserName + "",
            "employeePassword": Emailtemplate?.employeePassword + "",
            "languageCode": Emailtemplate?.languageCode + "",
            "attachments": "null",
        }


        axios.post("Employee/EmailEmployeeCredentials", location,
            {
                headers: { 'Content-Type': 'application/json' }
            }
        ).then(res => {
            if (res?.data?.data == "Success") {
                toast.success(res?.data?.data, {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                (handleClose1())
                setDis(false);
                setIsLoading(false);
            } else {
                const message = res?.data?.data ?? "";

                if (message.includes("BlockedEmails:")) {
                    setPopupMessage(formatBlockedEmailMessage(message));
                    setOpenPopup(true);
                } else if (res?.data?.data == "Invalid Email") {
                    toast.error("Unable to send the email because the recipient's email address is invalid or blocked.", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setDis(false);
                    setIsLoading(false);

                } else {
                    toast.error(res?.data?.responseMessage, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    setDis(false);
                    setIsLoading(false);
                }
            }
        }).catch(err => {
            console.log(err)
        })


    };
    useEffect(() => {
        handleBlur()
    }, [to, subject, body]);

    const handleBlur = () => {
        const strippedBody = body?.replace(/<p><br><\/p>/g, '')?.trim();
        setIsFormValid(to?.trim() !== '' && subject?.trim() !== '' && strippedBody !== '');
    };

    const [OpenPopup, setOpenPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const formatBlockedEmailMessage = (message) => {
        if (!message) return null;

        const blockedMatch = message.match(/BlockedEmails:\s*\(\s*(.*?)\s*\)/);
        const unBlockedMatch = message.match(/UnBlockedEmails:\s*\(\s*(.*?)\s*\)/);

        return {
            description:
                "Some recipients could not be processed because their email addresses are blocked. The remaining recipients will receive the email.",
            blockedEmails: blockedMatch?.[1]
                ?.split(",")
                .map(x => x.trim())
                .filter(Boolean) || [],
            unBlockedEmails: unBlockedMatch?.[1]
                ?.split(",")
                .map(x => x.trim())
                .filter(Boolean) || []
        };
    };


    const formats = [
        "strike",
        "size",
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        // 'background',
        'list',
        'align',
        // 'link',
        'image',
        // 'color',
        'indent',
        'clean',
        'blockquote', 'script'

    ];

    const modules = {
        toolbar: [
            ['undo', 'redo'],
            [{ 'size': [] }],
            [{ 'font': [] }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            // ['link'],
            ['clean'],

            // [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
        ],
    };


    const handleUndo = () => {
        const quill = quillRef?.current?.getEditor();
        quill?.history?.undo();
    };

    const handleRedo = () => {
        const quill = quillRef?.current?.getEditor();
        quill?.history?.redo();
    };
    const quillRef = React?.createRef();

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Dialog open={OpenPopup} onClose={() => setOpenPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Email Status</DialogTitle>

                <DialogContent dividers>
                    <Typography sx={{ fontWeight: 600, mb: 5 }}>
                        {popupMessage?.description}
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    height: "100%"
                                }}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "error.main", mb: 1 }}>
                                    Blocked Recipients
                                </Typography>

                                <List dense disablePadding>
                                    {popupMessage?.blockedEmails?.map((email, index) => (
                                        <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                                            <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                                                •
                                            </Box>

                                            <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                                                {email}
                                            </Typography>

                                        </ListItem>
                                    ))}
                                </List>
                            </Paper>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    border: "1px solid #e0e0e0",
                                    borderRadius: 2,
                                    height: "100%"
                                }}
                            >
                                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "success.main", mb: 1 }}>
                                    Recipients
                                </Typography>

                                <List dense disablePadding>
                                    {popupMessage?.unBlockedEmails?.map((email, index) => (
                                        <ListItem key={index} disableGutters sx={{ alignItems: "flex-start", py: 0.5 }}>

                                            <Box sx={{ width: 16, flexShrink: 0, fontSize: "1rem", lineHeight: 1.5 }}>
                                                •
                                            </Box>

                                            <Typography variant="body2" sx={{ flex: 1, whiteSpace: "normal", overflowWrap: "break-word", wordBreak: "break-word" }}>
                                                {email}
                                            </Typography>

                                        </ListItem>
                                    ))}
                                </List>

                            </Paper>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        variant="contained"
                        className="login-button-request"
                        onClick={() => {
                            setOpenPopup(false);
                            handleClose1();
                            setIsLoading(false);
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            <AppBar sx={{ position: "fixed", backgroundColor: "#1976d2" }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose1}
                        aria-label="close"
                        sx={{ color: "#fff" }}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography
                        sx={{ ml: 2, flex: 1, color: "#fff" }}
                        variant="h6"
                        component="div"
                    >
                        {"Send Email"}
                    </Typography>


                </Toolbar>
            </AppBar>


            <Box sx={{ padding: '20px', backgroundColor: "" }}>
                <ToastContainer />
                {/* <div dangerouslySetInnerHTML={{ __html: body }} /> */}
                <br />
                <b style={{ fontSize: "25px" }}>Send Email</b>
                <Box border={1}
                    borderLeft={1}
                    borderRight={1}
                    borderColor="#e4e7ec" sx={{ padding: "13px", backgroundColor: "#fff", marginTop: "5px" }}>
                    <span style={{ fontSize: "14px" }}>To <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <TextField placeholder="Email" onBlur={handleBlur} sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={to || ""} variant="outlined" size="small" onChange={(e) => setTo(e?.target?.value)} />
                    <br />
                    <span style={{ fontSize: "14px" }}>CC</span>
                    <br />
                    <TextField placeholder="CC" sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }} value={ccAddress || ""} variant="outlined" size="small" onChange={(e) => setCcAddress(e?.target?.value)} />
                    <br />

                    <span className='abc' style={{ fontSize: "14px" }}>Subject <span style={{ color: "red" }}>*</span></span>
                    <br />
                    <TextField onBlur={handleBlur} InputProps={{
                        readOnly: true,
                    }} placeholder="Subject" sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, backgroundColor: "#fff", marginTop: "2px", marginBottom: "5px" }}
                        value={subject || ""}
                        variant="outlined" size="small" onChange={(e) => setSubject(e?.target?.value)} />
                    <br />
                    <span style={{ fontSize: "14px" }}>Content<span style={{ color: "red" }}>*</span></span>
                    {/* <CKEditor
                    editor={ClassicEditor}
                    data={Emailtemplate?.body}
                    
                    onChange={(event, editor) => {
                        const data = editor.getData();
                        setBody(data)
                    }}
                /> */}
                    <div>
                        <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px" }}>
                            <UndoIcon />
                        </IconButton>
                        <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                            <RedoIcon />
                        </IconButton>

                        <ReactQuill
                            ref={quillRef}
                            modules={modules}
                            formats={formats}
                            value={body}
                            onChange={setBody}
                            className={body ? 'custom-styling-without-content' : 'custom-styling-without-content'}
                        />
                    </div>
                    <br />

                    {/* <Button
        variant="contained"
        sx={{ padding: "10px", marginRight: "10px" }}
        onClick={SendEmail}
        disabled={!isFormValid}
      >
        Send Email */}
                    {/* </Button> */}

                    {!isFormValid ? <Tooltip title="Please enter required fields." followCursor>
                        <span>
                            <Button
                                variant="contained"
                                sx={{ padding: "10px", marginRight: "10px" }}
                                disabled={!isFormValid}
                            >
                                Send Email
                            </Button>
                        </span>
                    </Tooltip> : <Button
                        variant="contained"
                        sx={{ padding: "10px", marginRight: "10px" }}
                        onClick={SendEmail}
                        disabled={Dis}
                    >
                        Send Email
                    </Button>}
                    <Button variant="outlined" sx={{ padding: "10px" }} onClick={handleClose1}>
                        Cancel
                    </Button>

                    {/* Tooltip to display when required fields are not filled */}
                    {/* {!isFormValid && (
        <span style={{ color: 'red', fontSize: '12px' }}>Please enter required fields.</span>
      )} */}
                </Box>
            </Box>
        </>
    )
}
